<template>
  <h2 class="font-roboto text-xl sm:text-2xl font-bold text-center text-gray-400 -mt-4">
    <slot></slot>
  </h2>
</template>
